import React, { useState } from "react";
import { IMAGES, BUYER_PROCESS, HOMEOWNER_PROCESS } from "../mock";
import { ButtonLink, Kicker } from "../components/UI";
import { PageHero } from "./FindRenovate";
import { useReveal } from "../hooks/useReveal";
import { useSiteImages } from "../context/SiteImages";

export default function Process() {
  const ref = useReveal();
  const { simg } = useSiteImages();
  const [tab, setTab] = useState("buyers");
  const steps = tab === "buyers" ? BUYER_PROCESS : HOMEOWNER_PROCESS;
  return (
    <div ref={ref}>
      <PageHero
        kicker="Our Process"
        title={<>A Better Renovation Starts With a <span className="text-gold-soft italic">Better Process.</span></>}
        sub="Renovations involve hundreds of decisions. Our goal is to make those decisions feel organized, intentional, and manageable."
        image={IMAGES.construction2}
        imageKey="hero_process"
      />

      <section className="py-20 md:py-28 bg-cream">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="flex justify-center mb-16">
            <div className="inline-flex border border-navy/15 p-1 bg-white">
              <button onClick={() => setTab("buyers")} className={`px-8 py-3 font-sans text-[12px] tracking-wide-nav uppercase transition-colors duration-300 ${tab === "buyers" ? "bg-navy text-cream" : "text-navy hover:text-gold"}`}>For Buyers</button>
              <button onClick={() => setTab("homeowners")} className={`px-8 py-3 font-sans text-[12px] tracking-wide-nav uppercase transition-colors duration-300 ${tab === "homeowners" ? "bg-navy text-cream" : "text-navy hover:text-gold"}`}>For Homeowners</button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-0">
            {steps.map((s, i) => (
              <div key={s.num} className={`group flex gap-6 py-8 border-b border-cream-dark ${i < 2 ? "md:border-t" : ""}`}>
                <span className="font-serif text-gold text-4xl md:text-5xl leading-none w-16 shrink-0">{s.num}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-[1.7rem] text-navy">{s.title}</h3>
                  <p className="font-sans text-charcoal/65 leading-relaxed mt-2">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-28 md:py-36 overflow-hidden">
        <div className="absolute inset-0">
          <img src={simg("process_cta", IMAGES.elegantInterior)} alt="Finished home" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-navy/80" />
        </div>
        <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
          <Kicker dark>Ready When You Are</Kicker>
          <h2 className="reveal font-serif font-medium text-cream text-4xl md:text-5xl mt-4 leading-tight">Let's Map Out Your Project Together.</h2>
          <div className="reveal flex justify-center mt-9"><ButtonLink to="/contact" variant="gold">Start Your Project</ButtonLink></div>
        </div>
      </section>
    </div>
  );
}
